import {
  ActionType,
  IGetClassFilterResponse,
} from "../../../models/messagemanagement/classFilterList";

export const classFilterListAction = () => {
  return {
    type: ActionType.GET_CLASS_LIST_FILTER,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.GET_CLASS_LIST_FILTER_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: IGetClassFilterResponse) => {
  return {
    type: ActionType.GET_CLASS_LIST_FILTER_SUCCESS,
    payload,
  };
};
